<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn active  btn-lg" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <i class="fa fa-angle-double-up" style="color: white;"></i>
    </button>
</div>
